import AiChatModal from "components/ai_chat/AiChatModal";
import AiChatPanel from "components/ai_chat/AiChatPanel";
import { buyerQaInputExtension } from "components/buyer_details/question_panel/buyerQaInputExtension";
import { AiContextProvider } from "lib/providers/AiContextProvider";

type QuestionPanelProps = {
  resourceId: string;
  resourceName: string;
  isOpen: boolean;
  onClose: () => void;
};
export function QuestionPanel({ resourceId, resourceName, isOpen, onClose }: QuestionPanelProps) {
  return (
    <AiChatModal isOpen={isOpen} onClose={onClose}>
      <AiContextProvider context={{ resourceId, resourceName, resourceType: "BUYER_QA" }}>
        <AiChatPanel
          inputExtension={buyerQaInputExtension}
          showCopyToClipboardButton={false}
          uiText={{
            title: `Ask me a question about ${resourceName}`,
            subtitle: "Your AI Assistant here to share relevant insights on public sector buyers.",
            inputPlaceholder: `Ask me a question about ${resourceName}`,
          }}
          suggestedQuestions={[
            {
              title: "Show me this buyer's awards",
              subtitle: "related to CRM software",
              prompt: "Show me this buyer's awards related to CRM software",
            },
            {
              title: "What procurement methods has this buyer used",
              subtitle: "to purchase technology services?",
              prompt:
                "What procurement methods has this buyer used to purchase technology services?",
            },

            {
              title: "What database technologies",
              subtitle: "are used by this organisation?",
              prompt: "What database technologies are used by this organisation?",
            },
            {
              title: "Name the certifications required",
              subtitle: "to supply services to this organisation",
              prompt: "Name the certifications required to supply services to this organisation",
            },
          ]}
        />
      </AiContextProvider>
    </AiChatModal>
  );
}
